import {
    IImmutableTask,
    IImmutableTaskItem,
    IImmutableTaskState,
} from 'phoenix2/state/sparxweb/apis/content.types';

// Returns whether the given task is a fast track quiz task
export const isFTQTask = (task: IImmutableTask) => task.get('task_type') === 'FAST_TRACK_QUIZ';

// Returns whether the given task item is to be used in the Quizes.
export const isFTQQuizItem = (item: IImmutableTaskItem) =>
    item.getIn(['labels', 'ftq_item']) === 'quiz_candidate';

// Returns whether the FTQ quiz has been completed given the task state.
export const isFTQQuizComplete = (taskState?: IImmutableTaskState) =>
    // FTQt (total number of questions) will only be set if the quiz has been completed.
    taskState && taskState.getIn(['progress', 'FTQt'], 0) > 0;

// Returns whether the FTQ has been skipped. It has been skipped if it has been
// completed (submitted) but the number of correct and wrong answers is 0.
export const isFTQQuizSkipped = (taskState?: IImmutableTaskState) =>
    taskState &&
    isFTQQuizComplete(taskState) &&
    taskState.getIn(['progress', 'FTQc'], 0) + taskState.getIn(['progress', 'FTQw'], 0) === 0;
